import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import he from "./locales/he.json";
import en from "./locales/en.json";
import es from "./locales/es.json";

const resources = {
  he: { translation: he },
  en: { translation: en },
  es: { translation: es },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "he", // Default language
    fallbackLng: "he",
    interpolation: {
      escapeValue: false, // React already escapes
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
